<template>
	<c-dialog ref="dialog" title="订单详情" height="75vh" :button="false">
		<c-title style="margin: .3rem .3rem 0;">订单信息</c-title>
		<c-detail style="padding-top: 0;">
			<c-detail-item label="销售单号">
				{{detailInfo.order_no || '-'}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2" label="三方订单号">
				{{detailInfo.third_party_order_no || '-'}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2" label="三方质检码">
				{{detailInfo.third_party_quality_code || '-'}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2" label="销售渠道">
				{{detailInfo.channel_name || '-'}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 1" label="客户">
				{{detailInfo.customer_name || '-'}}
			</c-detail-item>
			<c-detail-item label="订单状态">
				<!--详情接口不下发 display_state，状态由端内自己算，和列表同一套规则：售后(9/10/11) > 订单状态；异常关单是状态旁叠加的感叹号标志-->
				<c-state async dict="SALES_ORDER_STATE" :value="detailInfo.after_sale_state > 0 ? detailInfo.after_sale_state : detailInfo.order_state"></c-state>
				<!--手机端没有悬停，感叹号只作标识，具体原因看下方异常备注项-->
				<span v-if="orderType == 2 && detailInfo.abnormal_flag == 1" class="m-abnormal-help">!</span>
			</c-detail-item>
			<!--线下订单取消原因：仅已取消状态展示（系统超时取消、人工取消均落该字段）-->
			<c-detail-item v-if="orderType == 1 && Number(detailInfo.order_state) === 5" label="取消原因">
				{{detailInfo.cancel_reason || '-'}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2 && detailInfo.abnormal_flag == 1" label="异常备注">
				<span style="color: #e53e3e;">{{detailInfo.abnormal_remark || '-'}}</span>
			</c-detail-item>
			<c-detail-item label="收货人">
				{{detailInfo.receiver_name || '-'}}　{{detailInfo.receiver_phone || ''}}
			</c-detail-item>
			<c-detail-item label="收货地址">
				{{detailInfo.receiver_address || '-'}}
			</c-detail-item>
			<c-detail-item label="快递信息">
				{{detailInfo.express_company || '-'}}　{{detailInfo.express_no || ''}}
			</c-detail-item>
			<c-detail-item label="订单总金额">
				￥{{detailInfo.total_amount}}
			</c-detail-item>
			<c-detail-item label="已付款金额">
				￥{{detailInfo.paid_amount}}
			</c-detail-item>
			<c-detail-item label="退款金额">
				￥{{detailInfo.refund_amount}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2" label="预期结算金额">
				￥{{detailInfo.expect_settle_amount}}
			</c-detail-item>
			<c-detail-item v-if="orderType == 2" label="结算状态">
				<c-state async dict="SALE_SETTLE_STATE" :value="detailInfo.settle_state"></c-state>
			</c-detail-item>
			<c-detail-item label="付款时间">
				{{detailInfo.pay_date || '-'}}
			</c-detail-item>
			<c-detail-item v-if="detailInfo.order_type == 1" label="创建人">
				{{detailInfo.create_user_realname || '-'}}
			</c-detail-item>
			<c-detail-item label="订单创建时间">
				{{detailInfo.create_date || '-'}}
			</c-detail-item>
			<c-detail-item label="备注">
				{{detailInfo.remark || '-'}}
			</c-detail-item>
		</c-detail>

		<c-title style="margin: 0 .3rem;">产品信息</c-title>
		<view-list-card v-for="(item, i) in productList" :key="i" style="margin-bottom: .24rem; background: #F9F9F9;">
			<template v-if="item.level_type" #tag>
				<c-state dict="LEVEL_TYPE" :value="item.level_type" type="hollow"></c-state>
			</template>

			<template #name>
				{{[item.brand_name, item.model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}
			</template>

			<template #default>
				<c-field label="背贴码">{{item.produce_code}}</c-field>
				<c-field label="IMEI">{{item.imei}}</c-field>
				<c-field label="售卖类型"><c-state async dict="SALE_SELL_TYPE" :value="item.sell_type"></c-state></c-field>
				<c-field v-if="item.sell_type == 2" label="拆机项">
					<template v-if="item.dismantle_items">
						<template v-for="(temp, i) in JSON.parse(item.dismantle_items)">
							<span v-if="i">、</span>
							<c-state :key="i" dict="DISMANTLE_ITEM" :value="temp" color="#666"></c-state>
						</template>
					</template>
				</c-field>
				<c-field label="销售价">
					<span>￥{{item.sale_price}}</span>
					<label>成本价：</label>
					<span>￥{{item.cost_price}}</span>
				</c-field>
			</template>
		</view-list-card>

		<!--异常处理记录：线上订单才查，逐条展示标记/解除的操作流水（与运营端/PC 商户端同源，数据走 /sys/work/log/list）-->
		<template v-if="orderType == 2 && abnormalLogList.length">
			<c-title style="margin: 0 .3rem;">异常处理记录</c-title>
			<div class="m-abnormal-log">
				<div v-for="(item, i) in abnormalLogList" :key="i" class="m-abnormal-log-item">
					<p class="m-abnormal-log-remark">{{item.remark || '-'}}</p>
					<p class="m-abnormal-log-meta">{{item.create_user_realname || '-'}}　{{item.create_date || '-'}}</p>
				</div>
			</div>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'salesOrderDetail',

		props: {
			orderType: Number,
			orderId: [String, Number]
		},

		data() {
			return {
				detailInfo: {},
				productList: [],
				abnormalLogList: []
			}
		},

		methods: {
			open() {
				this.abnormalLogList = [];
				this.request({
					url: this.orderType == 1 ? '/offline/sale/order/detail' : '/online/sale/order/detail',
					data: {
						order_id: this.orderId
					},
					loading: true,
					success: data => {
						this.detailInfo = data.order;
						this.productList = data.products;
						if (this.orderType == 2) this.loadAbnormalLog();
						this.$refs.dialog.open();
					}
				});
			},

			/*********加载本单异常处理日志（线上订单 work_type=12，按 order_id 过滤；商户端不传 merchant_id，后端按登录商户过滤）**********/
			loadAbnormalLog() {
				this.request({
					url: '/sys/work/log/list',
					data: {
						work_type_id: 12,
						work_id: this.orderId,
						pageIndex: 1,
						pageSize: 50
					},
					success: data => {
						this.abnormalLogList = data || [];
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	// 状态旁叠加的异常关单红圈感叹号，与列表页 .m-abnormal-help 同款（移动端尺寸）
	.m-abnormal-help {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		margin-left: 8px;
		border: 2px solid #e53e3e;
		border-radius: 50%;
		font-size: 20px;
		color: #e53e3e;
		vertical-align: middle;
	}

	// 异常处理记录列表：移动端流水，处理详情为主、操作人+时间为辅
	.m-abnormal-log {
		margin: 0 .3rem .3rem;
		padding: 0 .24rem;
		background: #fff;
		border-radius: .12rem;
	}
	.m-abnormal-log-item {
		padding: .2rem 0;
		border-bottom: 1px solid #f0f0f0;
	}
	.m-abnormal-log-item:last-child {
		border-bottom: none;
	}
	.m-abnormal-log-remark {
		margin: 0;
		font-size: .28rem;
		color: #333;
		line-height: .4rem;
	}
	.m-abnormal-log-meta {
		margin: .08rem 0 0;
		font-size: .24rem;
		color: #999;
	}
</style>